import ConfirmServiceModal from "./ConfirmServiceModal";

export default ConfirmServiceModal;
